import yup from '../libraries/validator.library';

export const NotificationSchema = yup
  .object({
    flightCategory: yup.string().nullable(),
    flightCategoryKey: yup.number().required(),
    flightType: yup.string().nullable(),
    ioNo: yup.string().nullable(),
    location: yup.string().nullable(),
    reasonBy: yup.string().nullable(),
    requestDate: yup.string().nullable(),
    requestId: yup.number(),
    requestStatus: yup.string().nullable(),
    requestorName: yup.string().nullable(),
    requestorDistrict: yup.string().nullable(),
  })
  .defined();

export const NotificationListSchema = yup
  .object({
    notifications: yup
      .object({
        rows: yup.array().of(NotificationSchema).defined(),
      })
      .defined(),
  })
  .defined();

export const NotificationCountSchema = yup
  .object({
    count: yup.number(),
  })
  .defined();

export type INotification = yup.InferType<typeof NotificationSchema>;
export type INotificationList = yup.InferType<typeof NotificationListSchema>;
